import { Site } from "../types/siteType"

export function organizeSiteData(data: Site[]) {
    let res = data.map(val => {
        return {
            SiteName: val.SiteName,
            centerStatus: val.centerStatus,
            relatedHCPs: val.relatedHCPs,
            relatedPatients: val.relatedPatients,
            contactPerson: val.firstName && val.lastName
            ? `${val.firstName} ${val.lastName}`
            : '',
            email: val.email || '',
            phoneNumber: val.phoneNumber || '',
            centerAddress: val.street && val.zipCode && val.city && val.country
            ? `${val.street ?? ''} ${val.zipCode ?? ''} ${val.city ?? ''} ${val.country ?? ''} ${val.apartment ?? ''}`.trim()
            : '',
        }
    })

    return res
}
